import * as React from "react";
import { Event } from "../../../../../contracts";
import { EventCardPropsMapper } from "../../../../../helpers/CardProps";
import { RenderCard } from "../RenderCard/RenderCard";
import { CardProps } from "../../../../../typings/CardProps/CardProps";

export const renderInternalEvents = (state: any, endIndex: number, startIndex: number, events: Event[], cms: any, dict: any) => {
    let innerView: any[] = [];
    for (startIndex; startIndex < endIndex; startIndex++) {
        let sportEvent = events[startIndex];

        let props = EventCardPropsMapper[sportEvent.type](state, sportEvent, cms, dict) as CardProps;

        innerView.push(
            <RenderCard key={`k_card_${startIndex}`} {...props}/>
        );
    }

    return innerView;
}